// extracted by mini-css-extract-plugin
export default {"loader":"header_loader__JzPp+","container":"header_container__dY+2+","cardHeaderTagContainer":"header_cardHeaderTagContainer__qESPG"};